import {
    ExtendedConstructionNumber,
    GeneratedConstructionNumberStatus,
} from '@bpd-library/utilities';
import { useTranslate } from '@utilities/hooks';

import { FormattedStatus, StatusTranslations } from '.';

const CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS: {
    [key in GeneratedConstructionNumberStatus]: string;
} = {
    InPreparation: 'StatusLabel-InVoorbereiding',
    Available: 'Enum-ConstructionNumberStatus-Vrij',
    InOption: 'houses-overview-status-option',
    Sold: 'Enum-ConstructionNumberStatus-Verkocht',
    Reserved: 'Reserved',
    Rented: 'Enum-ProjectStatus-Verhuurd',
    UnderConstruction: 'UnderConstructionInhabited',
    AssigningOn: 'StatusLabel-AssigningOn',
};

/**
 * @description Takes an Extended Construction number and returns translated status and color
 * @param {ExtendedConstructionNumber} constructionNumber
 * @return {*}  {(FormattedStatus | undefined)}
 */
const formatConstructionNumberStatus = (
    constructionNumber: ExtendedConstructionNumber,
): FormattedStatus | undefined => {
    const { status, projectPhase } = constructionNumber;

    if (!status) return;

    switch (status) {
        case 'Available':
            return constructionNumber.projectPhase?.isRental
                ? StatusTranslations.FORMATTED.ForRent
                : StatusTranslations.FORMATTED.Available;

        case 'AssigningOn':
            const allocationDate = new Date(projectPhase?.allocationDate!).toLocaleDateString(
                window.__ENVIRONMENT_DETAILS__.languageIsoCode,
                {
                    day: 'numeric',
                    month: 'short',
                },
            );

            return {
                label: useTranslate('StatusLabel-AssigningOn.Dynamic', {
                    replace: [{ id: 'Date', value: allocationDate }],
                }),
                color: 'orange',
            };
        default:
            return StatusTranslations.FORMATTED[status];
    }
};

export { formatConstructionNumberStatus, CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS };
